import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Button } from '../components/ui/button';
import { AlertCircle } from 'lucide-react';
import { PARTNER_SERVICES_UNAVAILABLE_TEST_ID } from '../lib/partnerServicesAvailability';

export default function PartnerServicesComingSoon() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-slate-100 pt-20" data-testid={PARTNER_SERVICES_UNAVAILABLE_TEST_ID}>
      <div className="max-w-4xl mx-auto px-4 py-16 text-center">
        <AlertCircle className="w-16 h-16 text-yellow-500 mx-auto mb-6" />
        <h1 className="font-heading text-3xl font-bold text-slate-800 mb-4">
          {t('partner_services.coming_soon_title', 'Coming Soon')}
        </h1>
        <p className="text-slate-600 text-lg mb-8">
          {t(
            'partner_services.coming_soon_body',
            'Insurance and rental car partner services are being prepared. Check back soon.',
          )}
        </p>
        <Button onClick={() => navigate('/')} className="bg-signal-blue hover:bg-signal-blue-hover">
          {t('insurance.back_home', 'Back to Home')}
        </Button>
      </div>
    </div>
  );
}
